import Icon from '@material-ui/icons/MovieFilter';

import List from './List';
// import Show from './Show';

export default {
  name: 'comments/episode',
  icon: Icon,
  list: List,
  // show: Show,
};
